<template>
  <div>
    <v-card class="sf-card"
            flat>
      <v-img aspect-ratio="2.2"
             class="sf-completion__image"
             gradient="to top, rgba(11, 43, 87, .85) 0%, rgba(11, 43, 87, .2) 60%, rgba(11, 43, 87, 0) 100%"
             position="bottom center"
             src="/images/header3.jpg">
        <div class="sf-completion__caption">
          <v-icon class="mb-2"
                  color="white"
                  size="40">
            ti-circle-check
          </v-icon>
          <div class="sf-completion__title">
            <span v-if="attendance">{{ $t('yourRegistrationWasSuccessful') }}</span>
            <span v-else>{{$t('yourRegistrationWasSuccessfullyCanceled') }}</span>
          </div>
        </div>
      </v-img>
      <v-card-text class="sf-card__body">
        <span v-if="attendance">{{ $t('attendanceText') }}</span>
        <span v-else>{{ $t('nonAttendanceText') }}</span>
      </v-card-text>
      <v-divider v-if="attendance" />
      <event-details v-bind:registration-code="participant.invitationCode"
                     v-bind:event="event"
                     v-bind:participant="participant"
                     v-if="attendance" />
      <v-card-actions v-if="nextStepButton != null || previousStepButton != null">
        <v-btn color="primary"
               outlined
               v-if="previousStepButton != null"
               v-on:click="previousStep">
          {{ previousStepButton }}
        </v-btn>
        <v-spacer />
        <v-btn color="accent"
               depressed
               v-if="nextStepButton != null"
               v-on:click="nextStep">
          {{ nextStepButton }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import EventDetails from '@/components/registration/EventDetails'

  export default {
    components: {
      EventDetails
    },
    methods: {
      nextStep() {
        this.$emit('next-step')
      },
      previousStep() {
        this.$emit('previous-step')
      }
    },
    name: 'CompletionCard',
    props: {
      attendance: Boolean,
      event: Object,
      nextStepButton: String,
      participant: Object,
      previousStepButton: String
    }
  }
</script>

<style scoped>
  .sf-completion__image {
    border-radius: 16px 16px 0 0;
  }

  .sf-completion__caption {
    bottom: 0;
    color: #fff;
    left: 0;
    padding: 24px;
    position: absolute;
  }

  .sf-completion__title {
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -.02em;
    line-height: 1.2;
  }

  @media (max-width: 599px) {
    .sf-completion__caption {
      padding: 16px;
    }

    .sf-completion__title {
      font-size: 1.25rem;
    }
  }
</style>

<i18n>
  {
    "de": {
      "attendanceText": "Wir freuen uns, Sie zu unserer Hausmesse begrüßen zu dürfen. Ihre Registrierung wurde erfolgreich gespeichert. Ihren persönlichen Zugang in Form eines QR-Codes senden wir Ihnen kurz vor der Messe per E-Mail zu. Mit diesem können Sie sich während der Hausmesse anmelden.",
      "nonAttendanceText": "Wir bedauern, dass Sie nicht teilnehmen können. Ihre Abmeldung haben wir erhalten. Wir würden uns jedoch ganz besonders freuen, wenn wir Sie im nächsten Jahr wieder begrüßen dürfen!",
      "yourRegistrationWasSuccessful": "Ihre Registrierung war erfolgreich",
      "yourRegistrationWasSuccessfullyCanceled": "Leider haben wir Ihre Abmeldung erhalten"
    },
    "en": {
      "attendanceText": "We look forward to welcoming you to our trade fair. Your registration has been saved successfully. We will send you your personal access in the form of a QR code by email shortly before the fair. You can use it to log in during the fair.",
      "nonAttendanceText": "Wir bedauern, dass Sie nicht teilnehmen können. Ihre Abmeldung haben wir erhalten. Wir würden uns jedoch ganz besonders freuen, wenn wir Sie im nächsten Jahr wieder begrüßen dürfen!",
      "yourRegistrationWasSuccessful": "Your registration was successful",
      "yourRegistrationWasSuccessfullyCanceled": "Leider haben wir Ihre Abmeldung erhalten"
    }
  }
</i18n>